<template>
  <FiltersItemContent
    v-if="numberOfStopButtons.length"
  >
    <template #title>
      {{ $l('filters.stops.title') }}
    </template>
    <template #content>
      <div
        id="stops-filters"
        class="stops-filters"
      >
        <div
          v-for="(item, i) in numberOfStopButtons"
          :key="i"
          class="filtersStop"
          role="button"
          @click="numberOfStopsClick(item)"
        >
          <input
            :id="`stops_${i}`"
            :value="item.value"
            type="checkbox"
            :checked="item.isChecked"
            class="filtersStop__radio"
            :class="{
              'filtersStop__radio__checked': item.isChecked
            }"
            name="stops"
            autocomplete="off"
          >
          <label
            class="filtersStop__label"
            :for="`stops_${i}`"
            @click.prevent
          >
            <span
              class="icon filtersStop__icon"
              :class="item.icon"
            />
            <span>{{ item.text }}</span>
          </label>
        </div>
      </div>
    </template>
  </FiltersItemContent>
</template>

<script setup>
import { l } from '@utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();

const numberOfStopButtons = computed(() => {
	const numberOfStopButtons = [
		{
			isChecked: filtersStore.state.numStops === '0',
			icon: 'icon-zero-stop',
			text: l('filters.stops.stop_0'),
			value: '0',
			isVisible: resultQueryStore.state.response?.uniqueNumStops?.includes(0)
		},
		{
			isChecked: filtersStore.state.numStops === '1',
			icon: 'icon-one-stop',
			text: l('filters.stops.stop_1'),
			value: '1',
			isVisible: resultQueryStore.state.response?.uniqueNumStops?.includes(1)
		},
		{
			isChecked: filtersStore.state.numStops === null,
			icon: 'icon-any',
			text: l('filters.stops.stop_all'),
			value: null,
			isVisible: true
		}
	]
		.filter(item => item.isVisible);
	return numberOfStopButtons.length === 1 ? [] : numberOfStopButtons;
});

const numberOfStopsClick = (item) => {
	filtersStore.set({ key: 'numStops', value: item.value });
};
</script>

<style lang="scss">


</style>
